var DisplayCondition = /** @class */ (function () {
    function DisplayCondition() {
    }
    Object.defineProperty(DisplayCondition.prototype, "displayType", {
        get: function () {
            return this._displayType;
        },
        set: function (v) {
            this._displayType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DisplayCondition.prototype, "questionSet", {
        get: function () {
            return this._questionSet;
        },
        set: function (v) {
            this._questionSet = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DisplayCondition.prototype, "question", {
        get: function () {
            return this._question;
        },
        set: function (v) {
            this._question = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DisplayCondition.prototype, "answer", {
        get: function () {
            return this._answer;
        },
        set: function (v) {
            this._answer = v;
        },
        enumerable: true,
        configurable: true
    });
    DisplayCondition.prototype.getDisplay = function (assessment) {
        if (this._displayType === 'show') {
            if (this.shouldShow(assessment)) {
                return 'show';
            }
            return 'hide';
        }
        else if (this.shouldHide(assessment)) {
            return 'hide';
        }
        return 'show';
    };
    DisplayCondition.prototype.shouldShow = function (assessment) {
        return this.metAnswerCondition('show', assessment);
    };
    DisplayCondition.prototype.shouldHide = function (assessment) {
        return this.metAnswerCondition('hide', assessment);
    };
    DisplayCondition.prototype.metAnswerCondition = function (type, assessment) {
        if (this._displayType !== type) {
            return false;
        }
        var qs = assessment.getQuestionSetById(this.questionSet.id);
        if (!qs) {
            return false;
        }
        var q = qs.getQuestionById(this.question.id);
        if (!q) {
            return false;
        }
        if (q.hasAnswer(this.answer)) {
            // if (q.answer && q.answer.id && q.answer.id == this.answer.id) {
            return true;
        }
        return false;
    };
    return DisplayCondition;
}());
export { DisplayCondition };



// WEBPACK FOOTER //
// ./src/app/shared/models/display-condition.ts.pre-build-optimizer.js